/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsageOverviewDto } from '../../models/usage-overview-dto';

export interface AnalyticsOverviewGet$Plain$Params {
}

export function analyticsOverviewGet$Plain(http: HttpClient, rootUrl: string, params?: AnalyticsOverviewGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageOverviewDto>> {
  const rb = new RequestBuilder(rootUrl, analyticsOverviewGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsageOverviewDto>;
    })
  );
}

analyticsOverviewGet$Plain.PATH = '/analytics/overview';
